import script from "./StationDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./StationDetails.vue?vue&type=script&lang=ts&setup=true"

import "./StationDetails.vue?vue&type=style&index=0&id=f56d5ab0&lang=scss"

const __exports__ = script;

export default __exports__